import type { GroundAnalysis } from './analysis';
import { useClock } from '@/state/store';

/** Polar projection: horizon on the rim, zenith at centre, north at top. */
export function SkyChart({ result }: { result: GroundAnalysis }) {
  const passes: {t:number;x:number;y:number;visible:boolean}[][] = [];
  let segment: typeof passes[number] = [];
  for (const s of result.samples) {
    if (s.elevation < 0) { if(segment.length)passes.push(segment); segment=[]; continue; }
    const radius=(90-s.elevation)/90*85, az=s.azimuth*Math.PI/180;
    segment.push({t:s.t,x:110+Math.sin(az)*radius,y:110-Math.cos(az)*radius,visible:result.windows.some(w=>s.t>=w.startMs&&s.t<=w.endMs)});
  }
  if(segment.length)passes.push(segment);
  return <figure className="mt-2 rounded bg-[#0d202b] p-2">
    <svg viewBox="0 0 220 220" role="img" aria-label="Predicted satellite ground-site sky tracks, north up">
      {[85,57,28].map(r=><circle key={r} cx="110" cy="110" r={r} fill="none" stroke="#274856" />)}
      <path d="M25 110H195 M110 25V195" stroke="#274856"/>
      <g fill="#7ca1ad" fontSize="9" textAnchor="middle"><text x="110" y="16">N</text><text x="207" y="113">E</text><text x="110" y="210">S</text><text x="12" y="113">W</text><text x="142" y="108">60°</text><text x="173" y="108">30°</text></g>
      {passes.map((pass,i)=><g key={i}><polyline points={pass.map(p=>`${p.x},${p.y}`).join(' ')} stroke="#688793" strokeWidth="1" fill="none"/>{pass.filter(p=>p.visible).map(p=><circle key={p.t} cx={p.x} cy={p.y} r="1.6" fill="#7deaff" onClick={()=>useClock.getState().setSimTime(p.t)} className="cursor-pointer"><title>{new Date(p.t).toISOString()} · jump clock</title></circle>)}</g>)}
    </svg><figcaption className="text-[9px] text-slate-400">Predicted sky tracks · cyan meets the configured geometric constraints. Click a cyan sample to move the clock.</figcaption>
  </figure>;
}
